/* eslint-disable no-param-reassign, default-case, consistent-return */
import { formatAddressLabels } from '@gameday/common/formats/address'

function mapAddressType(type) {
  switch (type) {
    case 'subpremise':
      return 'subPremise'
    case 'street_number':
      return 'streetNumber'
    case 'route':
      return 'streetName'
    case 'locality':
      return 'suburb'
    case 'postal_town':
      return 'city'
    case 'administrative_area_level_1':
      return 'state'
    case 'administrative_area_level_2':
      return 'administrativeArea'
    case 'country':
      return 'country'
    case 'postal_code':
      return 'postalCode'
  }
}

export function processGooglePlaceAddress(place) {
  const { name, address_components } = place
  const addressParts = address_components.reduce((addressParts, component) => {
    const { types, long_name, short_name } = component
    addressParts[mapAddressType(types[0])] = {
      shortName: short_name,
      longName: long_name,
    }
    return addressParts
  }, {})

  const { subPremise, streetNumber, streetName, suburb, administrativeArea, postalCode, state, city, country } =
    addressParts

  const streetAddress = [
    ...(subPremise && streetNumber ? [`${subPremise.longName}/${streetNumber.longName}`] : []),
    ...(!subPremise && streetNumber ? [streetNumber.longName] : []),
    ...(!subPremise && !streetNumber && name ? [name] : []),
    ...(streetName ? [streetName.longName] : []),
  ]
    .filter(a => !!a)
    .join(' ')

  const { stateName } = formatAddressLabels(country.longName, addressParts)

  const newAddress = {
    street: streetAddress,
    // biome-ignore lint/complexity/useOptionalChain: TODO
    suburb: (suburb && suburb.longName) || (city && city.longName) || '',
    // biome-ignore lint/complexity/useOptionalChain: TODO
    city: (city && city.longName) || '',
    // biome-ignore lint/complexity/useOptionalChain: TODO
    postalCode: (postalCode && postalCode.longName) || '',
    // biome-ignore lint/complexity/useOptionalChain: TODO
    administrativeArea: (administrativeArea && administrativeArea.longName) || '',
    // biome-ignore lint/complexity/useOptionalChain: TODO
    state: stateName || (state && state.longName) || '',
    // biome-ignore lint/complexity/useOptionalChain: TODO
    stateCode: (state && state.shortName) || '',
    // biome-ignore lint/complexity/useOptionalChain: TODO
    country: (country && country.longName) || '',
    // biome-ignore lint/complexity/useOptionalChain: TODO
    countryCode: (country && country.shortName) || '',
  }

  return {
    newAddress,
    addressParts,
  }
}

export function getAddressString(address) {
  const { street, street2, suburb, postalCode, state, country } = address
  return [street, ...(street2 && street2.length > 0 ? [street2] : []), suburb, postalCode, state, country]
    .filter(a => a && String(a).trim().length > 0)
    .join(', ')
}
